import { useLanguage } from "../../../context/LanguageProvider";
import type { TocItem } from "../types";

interface BlogTableOfContentsProps {
    items: TocItem[];
}

// Sticky list of the article's <h2> headings (desktop only)
const BlogTableOfContents = ({ items }: BlogTableOfContentsProps) => {
    const { t } = useLanguage();

    if (items.length === 0) return null;

    return (
        <aside className="w-full lg:w-1/5 hidden lg:block sticky top-24 h-fit">
            <h2 className="text-lg font-bold text-gray-800 border-b border-gray-300 p-4 mb-5">
                {t.blog.tableOfContents}
            </h2>
            <ul className="space-y-3 list-none text-md px-4 lg:px-0">
                {items.map((item) => (
                    <li key={item.id}>
                        <a href={`#${item.id}`} className="text-gray-800 hover:underline">
                            {item.text}
                        </a>
                    </li>
                ))}
            </ul>
        </aside>
    );
};

export default BlogTableOfContents;